module.exports = __webpack_public_path__ + "img/workout-notebook_B095QM31Y7.fb5309d0.jpg";